import React, { useState, useEffect, createContext } from "react";
import { useNavigate } from "react-router-dom";

const MatriculaContext = createContext();

const MatriculaProvider = ({ children }) => {
  const [procesoMatricula, setProcesoMatricula] = useState({});
  const [obtenerDatosEstudiante, setObtenerDatosEstudiante] = useState({});
  const [obtenerDatosEstudianteSinFiltro, setObtenerDatosEstudianteSinFiltro] = useState([]);
  const [listadoAsignaturas, setListadoAsignaturas] = useState([]);
   
  const [idAsignaturas, setIdAsignaturas] = useState({});
  const [gruposHabilitados, setGruposHabilitados] = useState([]);
  const [cargandoGrupos, setCargandoGrupos] = useState(false);
  const [listadoSoporte, setListadoSoporte] = useState([]);
  const [listadoRequisitosMatricula, setlistadoRequisitosMatricula] = useState([]);
  const [listadoPeriodo, setListadoPeriodo] = useState([]);
  const [listadoPrograma, setListadoPrograma] = useState([]);
  const [listadoFranjas, setListadoFranjas] = useState([]);
  const [seleccionPrograma, setSeleccionPrograma] = useState(null);
  const [listadoInforMatriDocumento, setListadoInforMatriDocumento] = useState([]);
  const [obtenerReglamentoEstudios, setObtenerReglamentoEstudios] = useState([]);
  const [obtenerSegurosAccidentes, setObtenerSegurosAccidentes] = useState([]);
  const [obtenerEmpresasSegurosAccidentes, setObtenerEmpresasSegurosAccidentes,] = useState([]);
  const [obtenerSegurosAccidentesEstudiante, setObtenerSegurosAccidentesEstudiante] = useState([]);
  const [mostrarAsignaturas, setMostrarAsignaturas] = useState(false);
  const [mostrarListadoFranjas, setMostrarListadoFranjas] = useState(false);
  const [franjaSeleccionadaAsignaturas, setFranjaSeleccionadaAsignaturas] = useState("");
  const [franjaSeleccionadaHorario, setFranjaSeleccionadaHorario] = useState("");
  const [multifranjas, setMultifranjas] = useState(null);
  const [matriculaAutomatica, setMatriculaAutomatica] = useState(null);

  //MÓDULO HORARIO
  const [listadoAsignaturasEstudiante, setListadoAsignaturasEstudiante] = useState([]);
  const [idGruposHabilitados, setIdGruposHabilitados] = useState({});
  const [alertaMensaje, setAlertaMensaje] = useState('')
  const [disableListadoFranjas, setDisableListadoFranjas] = useState(false)
  const [franjaActual, setFranjaActual] = useState("");
  const [mostrarAlerta, setMostrarAlerta] = useState(false);

  const token = localStorage.getItem("token");
  //msg de exitoso
  const [
    msgExitosoTable,
    setMsgExitosoTable,
  ] = useState({});

  const seteoDeObjectMatricula = (accion) => {
    switch (accion) {
      case "inicioMatricula":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "active",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "",
            },
            Horario: {
              id: 4,
              clase: "",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "",
            },
          };
          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextUpdateDatos":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "active",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "",
            },
            Horario: {
              id: 4,
              clase: "",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "",
            },
          };

          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextReglamento":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "completed",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "active",
            },
            Horario: {
              id: 4,
              clase: "",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "",
            },
          };

          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextSeguro":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "completed",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "completed",
            },
            Horario: {
              id: 4,
              clase: "active",
              horario1: {
                estado: true,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "",
            },
          };

          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextHorario":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "completed",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "completed",
            },
            Horario: {
              id: 4,
              clase: "active",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: true,
              },
            },
            PagoAll: {
              id: 5,
              clase: "",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "",
            },
          };
          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextSeleccionHorario":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "completed",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "completed",
            },
            Horario: {
              id: 4,
              clase: "completed",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "active",
              pago: {
                estado: true,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "",
            },
          };
          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextPago":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "completed",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "completed",
            },
            Horario: {
              id: 4,
              clase: "completed",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "active",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: true,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "",
            },
          };
          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextPagoAhora":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "completed",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "completed",
            },
            Horario: {
              id: 4,
              clase: "completed",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "completed",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: false,
              },
            },
            confirmacion: {
              id: 6,
              clase: "completed",
            },
          };
          setProcesoMatricula(estadoMatricula);
        }
        break;
      case "nextPagoDespues":
        {
          let estadoMatricula = {
            ActualizacionDatos: {
              id: 1,
              clase: "completed",
            },
            ReglamentoEstudios: {
              id: 2,
              clase: "completed",
            },
            SeguroAccidentes: {
              id: 3,
              clase: "completed",
            },
            Horario: {
              id: 4,
              clase: "completed",
              horario1: {
                estado: false,
              },
              horario2: {
                estado: false,
              },
            },
            PagoAll: {
              id: 5,
              clase: "completed",
              pago: {
                estado: false,
              },
              modalidadPago: {
                estado: false,
                pagarMasTarde: true,
              },
            },
            confirmacion: {
              id: 6,
              clase: "active",
            },
          };
          setProcesoMatricula(estadoMatricula);
        }
        break;
       
      default:
        break;
    }
  };

  const [seleccionPeriodo, setSeleccionPeriodo] = useState(null);
  return (
    <MatriculaContext.Provider
      value={{
        procesoMatricula,
        setProcesoMatricula,
        seteoDeObjectMatricula,
        obtenerDatosEstudianteSinFiltro,
        setObtenerDatosEstudianteSinFiltro,
        obtenerDatosEstudiante,
        setObtenerDatosEstudiante,
        listadoAsignaturas,
        setListadoAsignaturas,
        setIdAsignaturas,
        idAsignaturas,
        setGruposHabilitados,
        gruposHabilitados,
        cargandoGrupos,
        setCargandoGrupos,
        listadoSoporte,
        setListadoSoporte,
        listadoRequisitosMatricula,
        setlistadoRequisitosMatricula,
        listadoPeriodo,
        setListadoPeriodo,
        listadoPrograma,
        seleccionPrograma,
        setSeleccionPrograma,
        setListadoPrograma,
        listadoInforMatriDocumento,
        setListadoInforMatriDocumento,
        obtenerReglamentoEstudios,
        setObtenerReglamentoEstudios,
        obtenerSegurosAccidentes,
        setObtenerSegurosAccidentes,
        obtenerEmpresasSegurosAccidentes,
        setObtenerEmpresasSegurosAccidentes,
        obtenerSegurosAccidentesEstudiante,
        setObtenerSegurosAccidentesEstudiante,
        listadoAsignaturasEstudiante,
        setListadoAsignaturasEstudiante,
        idGruposHabilitados, setIdGruposHabilitados,
        msgExitosoTable,
        setMsgExitosoTable,
        seleccionPeriodo, setSeleccionPeriodo,
        listadoFranjas, setListadoFranjas,
        mostrarAsignaturas, setMostrarAsignaturas,
        mostrarListadoFranjas, setMostrarListadoFranjas,
        franjaSeleccionadaAsignaturas, setFranjaSeleccionadaAsignaturas,
        franjaSeleccionadaHorario, setFranjaSeleccionadaHorario,
        alertaMensaje, setAlertaMensaje,
        disableListadoFranjas, setDisableListadoFranjas,
        multifranjas, setMultifranjas,
        franjaActual, setFranjaActual,
        mostrarAlerta, setMostrarAlerta,
        matriculaAutomatica,  setMatriculaAutomatica
      }}
    >
      {children}
    </MatriculaContext.Provider>
  );
};

export { MatriculaContext };

export default MatriculaProvider;
